import IconCalendar from "../icon/IconCalendar";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

export default function IconButtonCalendar(props: IconButtonProps) {
    return <IconButtonContainer {...props}>
        <IconCalendar />
    </IconButtonContainer>
}
